export default __webpack_public_path__ + "static/sp-slider-b033deaf150d3edbe8c37afc09fff24b.png";